document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('main-nav');

    window.addEventListener('scroll', function () {
        if (window.scrollY > 150) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    });
});


jQuery(document).ready(function ($) {

    function isSamePageAnchorLink(link) {
        return (
            location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '') &&
            location.hostname === link.hostname &&
            link.hash
        );
    }

    // 1. #navbarNavOffcanvas 内のアンカークリックでオフキャンバスを閉じる + スクロール
    $('#navbarNavOffcanvas a').click(function (e) {
        if (isSamePageAnchorLink(this)) {
            e.preventDefault();
            var target = $(this.hash);
            if (target.length) {
                $('html, body').animate({ scrollTop: target.offset().top }, 300);
                $('#navbarNavOffcanvas').offcanvas('hide');
            }
        }
    });

    // 2. それ以外のアンカーリンクに対するスムーズスクロール
    $('a').not('#navbarNavOffcanvas a').click(function (e) {
        if (isSamePageAnchorLink(this)) {
            e.preventDefault();
            var target = $(this.hash);
            if (target.length) {
                $('html, body').animate({ scrollTop: target.offset().top }, 300);
            }
        }
    });

});
